export default __webpack_public_path__ + "static/media/5.f6e3b9e1.jpg";